import React, { useState, useEffect } from 'react';
import { db } from '../../services/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const GeofenceSettings = () => {
  const [form, setForm] = useState({ latitude: '', longitude: '', radius: '' });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const docRef = doc(db, 'configuracion', 'geocerca');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setForm({
          latitude: data.latitude?.toString() || '',
          longitude: data.longitude?.toString() || '',
          radius: data.radius?.toString() || ''
        });
      }
    } catch (error) {
      setMessage('Error al cargar configuración');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const docRef = doc(db, 'configuracion', 'geocerca');
      await setDoc(docRef, {
        latitude: parseFloat(form.latitude),
        longitude: parseFloat(form.longitude),
        radius: parseFloat(form.radius)
      });
      setMessage('✅ Ubicación guardada correctamente');
    } catch (error) {
      setMessage(`❌ Error al guardar: ${error.message}`);
    }
    setLoading(false);
  };

  return (
    <div className="geofence-settings">
      <h3>Configuración de Ubicación (Geocerca)</h3>
      <form onSubmit={handleSubmit} className="user-form">
        <div className="form-group">
          <label>Latitud</label>
          <input
            type="number"
            step="any"
            value={form.latitude}
            onChange={(e) => setForm({...form, latitude: e.target.value})}
            required
            placeholder="19.432608"
          />
        </div>
        <div className="form-group">
          <label>Longitud</label>
          <input
            type="number"
            step="any"
            value={form.longitude}
            onChange={(e) => setForm({...form, longitude: e.target.value})}
            required
            placeholder="-99.133209"
          />
        </div>
        <div className="form-group">
          <label>Radio (metros)</label>
          <input
            type="number"
            step="any"
            value={form.radius}
            onChange={(e) => setForm({...form, radius: e.target.value})}
            required
            placeholder="100"
          />
        </div>
        <button type="submit" disabled={loading} className="btn-create">
          {loading ? 'Guardando...' : 'Guardar Ubicación'}
        </button>
      </form>
      {message && <div className="message">{message}</div>}
    </div>
  );
};

export default GeofenceSettings;